import { OpenGraphArticle } from 'next-seo/lib/types';

import { Article } from '@/graphql/generated';

export const generateOpenGraphArticleObject = (article: Article): OpenGraphArticle => {
  const createdAtString = typeof article?.createdAt === 'string' ? article?.createdAt : undefined;
  const createdAtArr = createdAtString?.split('T') || [];
  const createdAtTime = createdAtArr[createdAtArr?.length - 1];
  return {
    publishedTime: article?.creationDate && createdAtTime ? `${article?.creationDate}T${createdAtTime}` : undefined,
    modifiedTime: typeof article?.updatedAt === 'string' ? article?.updatedAt : undefined,
    tags: article?.tags.data.map((el) => el.attributes?.name || ''),
  };
};
